// ── TEMPORARY: all-schools demo on 16 Sept 2026 ─────────────────────────────
// Until this moment the login forms (school, admin, faculty) do not insist on a
// complete 6-character CAPTCHA — anything (even blank) is sent, and the server
// accepts it (Backend2 UserController validateCaptchaOrThrow, same window).
// Switches back on by itself; REACT_APP_CAPTCHA_RELAXED_UNTIL overrides at build.
const RELAXED_UNTIL_MS = Date.parse(process.env.REACT_APP_CAPTCHA_RELAXED_UNTIL || "2026-09-17T00:00:00+05:30");

export const isCaptchaRelaxed = () => Number.isFinite(RELAXED_UNTIL_MS) && Date.now() < RELAXED_UNTIL_MS;
